import { render, staticRenderFns } from "./DatatableEditSelectDialog.vue?vue&type=template&id=4580b068&"
import script from "./DatatableEditSelectDialog.vue?vue&type=script&lang=js&"
export * from "./DatatableEditSelectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports